import { render, staticRenderFns } from "./AdminProducts.vue?vue&type=template&id=58b01ad0&"
import script from "./AdminProducts.vue?vue&type=script&lang=js&"
export * from "./AdminProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports